import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';

@Injectable()
export class UsageService {
  /**
   * This method will log usage views.
   */
  public appID: any;
  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe((params) => {
      if (params.app === 'eeh') {
        this.appID = 2;
      } else if (params.app === 'student') {
        this.appID = 10; // Added this check for STUD-187
      }
    });
  }
  public logUsageViaSQS(contentDetails: string, referringType: string, viewType: string, productId?: number) {
    const currentUrl = window.location.href;
    let sqsUsageUrl;
    if (currentUrl.indexOf('eeh') !== -1) {
      sqsUsageUrl = '/compare-animals/api/v1/sqsusage/' + contentDetails + '/' + referringType + '/' + viewType;
    } else if (currentUrl.indexOf('student') !== -1) {
      sqsUsageUrl = '/compare-service/api/v1/sqsusage/' + contentDetails + '/' + referringType + '/' + viewType;
    }
    if (this.appID) {
      sqsUsageUrl = sqsUsageUrl + '?productId=' + this.appID;
    }
    $.ajax({
      url: sqsUsageUrl,
      xhrFields: { withCredentials: true },
      type: 'GET',
      error: (er) => {
        if (er.status !== 200) {
          console.log('Usage error: ' + er.statusText + '::' + sqsUsageUrl);
        }
      }
    });
  }
}
